import React from 'react';
import { graphql } from 'gatsby';

import MQLPage from '../components/MQLPage';

const ResourceContentTemplate = ({
  data: { form, relatedContent },
  pageContext,
  ...props
}) => (
  <MQLPage
    form={form}
    relatedContent={relatedContent.nodes}
    {...pageContext}
    {...props}
  />
);

export const query = graphql`
  query relatedResourceContent(
    $id: String!
    $relatedValues: [GraphCMS_ResourceType!]
    $hubSpotFormId: String!
  ) {
    form: hubSpotForm(id: { eq: $hubSpotFormId }) {
      id
      name
      metaData {
        name
        value
      }
      formFieldGroups {
        fields {
          name
          label
          fieldType
          required
          options {
            label
            value
            displayOrder
            doubleData
            hidden
            description
            readOnly
          }
          defaultValue
          type
          hidden
          placeholder
        }
      }
    }
    relatedContent: allGraphCmsResource(
      filter: { id: { ne: $id }, type: { in: $relatedValues } }
      limit: 2
    ) {
      nodes {
        id
        slug
        friendlySlug
        friendlyStartDate
        title
        subTitle
        coverImage {
          id
          url
          handle
          width
          height
        }
        speakers {
          name
          title
          twitterHandle
          bio
          photo {
            id
            url
            handle
            width
            height
          }
        }
        content
        externalUrl
        location
        starts
        ends
        type
        linkPath
      }
    }
  }
`;

export default ResourceContentTemplate;
